const educationCenterArchive = document.querySelector('.education-center-archive');
const filterForm = educationCenterArchive?.querySelector('#education-center-filters');

if (filterForm) {
  const resultsStatus = educationCenterArchive.querySelector('.education-center-results-status');
  const customSelectControllers = [];
  let activeRequest;

  const closeCustomSelect = (controller, restoreFocus = false) => {
    controller.root.classList.remove('is-open');
    controller.trigger.setAttribute('aria-expanded', 'false');
    controller.options.hidden = true;

    controller.optionButtons.forEach((option) => {
      option.tabIndex = -1;
    });

    if (restoreFocus) {
      controller.trigger.focus();
    }
  };

  const syncCustomSelect = (controller) => {
    const selectedOption = controller.nativeSelect.options[controller.nativeSelect.selectedIndex];

    if (!selectedOption) {
      return;
    }

    controller.label.textContent = selectedOption.textContent.trim();

    controller.optionButtons.forEach((option) => {
      option.setAttribute('aria-selected', option.dataset.value === controller.nativeSelect.value ? 'true' : 'false');
    });
  };

  const openCustomSelect = (controller, requestedIndex, moveFocus = false) => {
    customSelectControllers.forEach((otherController) => {
      if (otherController !== controller) {
        closeCustomSelect(otherController);
      }
    });

    const selectedIndex = controller.optionButtons.findIndex(
      (option) => option.dataset.value === controller.nativeSelect.value,
    );
    const focusIndex = Number.isInteger(requestedIndex)
      ? requestedIndex
      : Math.max(0, selectedIndex);

    controller.root.classList.add('is-open');
    controller.trigger.setAttribute('aria-expanded', 'true');
    controller.options.hidden = false;
    controller.optionButtons[focusIndex].tabIndex = 0;

    if (moveFocus) {
      controller.optionButtons[focusIndex].focus();
    }
  };

  const selectCustomOption = (controller, option) => {
    const valueChanged = controller.nativeSelect.value !== option.dataset.value;

    controller.nativeSelect.value = option.dataset.value;
    syncCustomSelect(controller);
    closeCustomSelect(controller, true);

    if (valueChanged) {
      controller.nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  filterForm.querySelectorAll('[data-custom-select]').forEach((root) => {
    const nativeSelect = root.querySelector('select');
    const customUi = root.querySelector('[data-custom-select-ui]');
    const trigger = root.querySelector('[data-custom-select-trigger]');
    const label = root.querySelector('[data-custom-select-label]');
    const options = root.querySelector('[data-custom-select-options]');
    const optionButtons = Array.from(options.querySelectorAll('[role="option"]'));
    const fieldLabel = filterForm.querySelector(`label[for="${nativeSelect.id}"]`);
    const controller = {
      root,
      nativeSelect,
      trigger,
      label,
      options,
      optionButtons,
    };

    nativeSelect.hidden = true;
    nativeSelect.setAttribute('aria-hidden', 'true');
    nativeSelect.tabIndex = -1;
    customUi.hidden = false;

    if (fieldLabel) {
      fieldLabel.htmlFor = trigger.id;
    }

    customSelectControllers.push(controller);
    syncCustomSelect(controller);

    trigger.addEventListener('click', () => {
      if (trigger.getAttribute('aria-expanded') === 'true') {
        closeCustomSelect(controller, true);
        return;
      }

      openCustomSelect(controller);
    });

    trigger.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeCustomSelect(controller, true);
        return;
      }

      if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
        return;
      }

      event.preventDefault();

      if (event.key === 'Home') {
        openCustomSelect(controller, 0, true);
        return;
      }

      if (event.key === 'End') {
        openCustomSelect(controller, optionButtons.length - 1, true);
        return;
      }

      const selectedIndex = optionButtons.findIndex(
        (option) => option.dataset.value === nativeSelect.value,
      );
      const direction = event.key === 'ArrowDown' ? 1 : -1;
      const nextIndex = (selectedIndex + direction + optionButtons.length) % optionButtons.length;

      openCustomSelect(controller, nextIndex, true);
    });

    optionButtons.forEach((option, optionIndex) => {
      option.addEventListener('click', () => selectCustomOption(controller, option));
      option.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeCustomSelect(controller, true);
          return;
        }

        if (event.key === 'Tab') {
          closeCustomSelect(controller);
          return;
        }

        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          selectCustomOption(controller, option);
          return;
        }

        if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
          return;
        }

        event.preventDefault();
        let nextIndex = optionIndex;

        if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = optionButtons.length - 1;
        } else if (event.key === 'ArrowDown') {
          nextIndex = (optionIndex + 1) % optionButtons.length;
        } else {
          nextIndex = (optionIndex - 1 + optionButtons.length) % optionButtons.length;
        }

        option.tabIndex = -1;
        optionButtons[nextIndex].tabIndex = 0;
        optionButtons[nextIndex].focus();
      });
    });
  });

  document.addEventListener('click', (event) => {
    customSelectControllers.forEach((controller) => {
      if (!controller.root.contains(event.target)) {
        closeCustomSelect(controller);
      }
    });
  });

  const getResults = () => educationCenterArchive.querySelector('.education-center-results');

  const getPageFromUrl = (url) => {
    const pageFromQuery = Number.parseInt(url.searchParams.get('paged'), 10);
    const pageFromPath = url.pathname.match(/\/page\/(\d+)\/?$/);

    if (Number.isInteger(pageFromQuery) && pageFromQuery > 0) {
      return pageFromQuery;
    }

    return pageFromPath ? Number.parseInt(pageFromPath[1], 10) : 1;
  };

  const buildArchiveUrl = (page = 1) => {
    const url = new URL(filterForm.action, window.location.origin);
    const topic = filterForm.elements.topic.value;
    const sort = filterForm.elements.sort.value;

    if (topic) {
      url.searchParams.set('topic', topic);
    }

    if (sort === 'oldest') {
      url.searchParams.set('sort', sort);
    }

    if (page > 1) {
      url.searchParams.set('paged', page);
    }

    return url;
  };

  const setLoading = (loading) => {
    const results = getResults();

    educationCenterArchive.classList.toggle('is-loading', loading);

    if (results) {
      results.setAttribute('aria-busy', loading ? 'true' : 'false');
    }
  };

  const updateResults = async (page = 1, updateHistory = true) => {
    activeRequest?.abort();
    const currentRequest = new AbortController();

    activeRequest = currentRequest;
    setLoading(true);

    const formData = new FormData(filterForm);
    formData.set('action', 'xds_filter_education_center');
    formData.set('nonce', filterForm.dataset.nonce);
    formData.set('paged', page.toString());

    try {
      const response = await fetch(filterForm.dataset.ajaxUrl, {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
        signal: currentRequest.signal,
      });
      const payload = await response.json();

      if (!response.ok || !payload.success || !payload.data?.html) {
        throw new Error('The Education Center results could not be loaded.');
      }

      const documentFragment = new DOMParser().parseFromString(payload.data.html, 'text/html');
      const nextResults = documentFragment.querySelector('.education-center-results');
      const currentResults = getResults();

      if (!nextResults || !currentResults) {
        throw new Error('The Education Center results were incomplete.');
      }

      currentResults.replaceWith(nextResults);
      filterForm.elements.paged.value = page.toString();

      if (updateHistory) {
        window.history.pushState({}, '', buildArchiveUrl(page));
      }

      resultsStatus.textContent = payload.data.foundPosts === 1
        ? '1 Education Center post shown.'
        : `${payload.data.foundPosts} Education Center posts shown.`;
    } catch (error) {
      if (error.name !== 'AbortError') {
        window.location.assign(buildArchiveUrl(page));
      }
    } finally {
      if (activeRequest === currentRequest) {
        setLoading(false);
      }
    }
  };

  filterForm.addEventListener('change', (event) => {
    if (event.target.matches('select')) {
      const controller = customSelectControllers.find(
        (customSelectController) => customSelectController.nativeSelect === event.target,
      );

      if (controller) {
        syncCustomSelect(controller);
      }

      updateResults(1);
    }
  });

  filterForm.addEventListener('submit', (event) => {
    event.preventDefault();
    updateResults(1);
  });

  educationCenterArchive.addEventListener('click', (event) => {
    const paginationLink = event.target.closest('.education-center-pagination a.page-numbers');

    if (!paginationLink) {
      return;
    }

    event.preventDefault();
    updateResults(getPageFromUrl(new URL(paginationLink.href)));
  });

  window.addEventListener('popstate', () => {
    const url = new URL(window.location.href);
    const topic = url.searchParams.get('topic') || '';
    const sort = url.searchParams.get('sort') === 'oldest' ? 'oldest' : 'newest';

    filterForm.elements.topic.value = topic;
    filterForm.elements.sort.value = sort;
    customSelectControllers.forEach(syncCustomSelect);
    updateResults(getPageFromUrl(url), false);
  });
}
